import type { Example } from '../types';

export const postProcessingExample: Example = {
  id: 'post-processing',
  title: 'Post-Processing — SSAO & Bloom',
  categoryId: 'viewer',
  description: 'scene_ssao(), scene_bloom(), scene_shadows() — all tunable',
  scadCode: `/* Post-Processing — SSAO & Bloom */

// markdown:tip
// **Post-Processing** — \`scene_ssao()\` adds screen-space ambient occlusion
// (darkens crevices). \`scene_bloom()\` adds glow around bright/emissive
// surfaces. \`scene_shadows()\` enables soft shadows. Toggle each effect and
// tune the sliders to see the difference.

/* [Ambient Occlusion] */

// Enable SSAO
ssao_on = true;

// SSAO intensity
ssao_intensity = 4.0; // [0.5:0.25:15.0] {ssao_on == true}

// SSAO radius
ssao_radius = 2.0; // [0.2:0.1:8.0] {ssao_on == true}

/* [Bloom] */

// Enable bloom
bloom_on = true;

// Bloom intensity
bloom_intensity = 0.6; // [0.05:0.05:3.0] {bloom_on == true}

// Bloom threshold (surfaces brighter than this glow)
bloom_threshold = 0.85; // [0.1:0.05:1.5] {bloom_on == true}

/* [Shadows] */

// Enable shadows
shadows_on = true;

// Shadow softness
shadow_soft = true; // {shadows_on == true}

// Shadow opacity
shadow_intensity = 0.4; // [0:0.05:1.0] {shadows_on == true}

/* [Emissive Subject] */

// Emissive sphere brightness (drives bloom)
emissive_strength = 1.5; // [0:0.1:4.0]

// Emissive color
// color
emissive_color = [1.0, 0.6, 0.1];

// --- parameters end ---

if (ssao_on)
  scene_ssao(enabled=1, intensity=ssao_intensity, radius=ssao_radius);
else
  scene_ssao(enabled=0);

if (bloom_on)
  scene_bloom(enabled=1, intensity=bloom_intensity, threshold=bloom_threshold, smoothing=0.04);
else
  scene_bloom(enabled=0);

if (shadows_on)
  scene_shadows(enabled=1, soft=shadow_soft ? 1 : 0, intensity=shadow_intensity, map_size=2048);
else
  scene_shadows(enabled=0);

// Lighting
light_directional(color=[1.0, 0.97, 0.9], position=[80, -60, 120], intensity=1.6);
light_ambient(color=[1,1,1], intensity=0.3);

$fn = 64;

// Emissive central sphere — bright enough to trigger bloom
color(emissive_color)
material(material_def(
  emissive=emissive_color,
  emissive_intensity=emissive_strength,
  roughness=0.2
))
sphere(r=15);

// Surrounding matte geometry to show SSAO in crevices
color([0.72, 0.70, 0.68])
material(material_def(roughness=0.7)) {
  // Ring of small cubes packed tightly against center
  for (a = [0:45:359])
    rotate([0, 0, a])
    translate([24, 0, 0])
      cube([12, 12, 12], center=true);
  // Outer ring
  for (a = [22.5:45:359])
    rotate([0, 0, a])
    translate([40, 0, -4])
      cube([10, 10, 10], center=true);
}

// Floor
color([0.15, 0.15, 0.17])
material(material_def(roughness=0.95))
translate([0, 0, -18])
  cube([120, 120, 2], center=true);
`,
};
